/* SG Wrought Iron | Direct PDF export | no print dialog | no external libraries.
 * Place in Shopify Assets as sg-calculator-pdf.js.
 * Works with SGCalculator.printReport({title,rows,diagram,disclaimer}).
 * Generates A4 PDF with clickable logo/name/website link, no footer.
 * Logo is taken from Shopify header if image is CORS-compatible; otherwise clean text branding.
 */
window.SGCalculator = window.SGCalculator || {};
(function (api) {
  'use strict';
  const SITE = 'https://sgwroughtiron.co.uk/';
  const encoder = new TextEncoder();
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const ascii = value => String(value == null ? '' : value).replace(/[\u2010-\u2015]/g, '-').replace(/[\u2018\u2019]/g, "'").replace(/[\u201c\u201d]/g, '"').replace(/\u00d7/g, 'x').replace(/[^\x20-\x7e]/g, '?');
  const pdfstr = value => '(' + ascii(String(value == null ? '' : value).replace(/\u00b0/g, '__SG_DEG__')).replace(/[\\()]/g, '\\$&').replace(/__SG_DEG__/g, '\\260') + ')';
  const fmt = value => Number.isFinite(value) ? Math.round(value).toLocaleString('en-GB') : '-';
  api.format = fmt;

  api.downloadSVG = (svg, filename) => {
    if (!svg) return;
    const copy = svg.cloneNode(true);
    copy.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    const blob = new Blob([new XMLSerializer().serializeToString(copy)], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename || 'sg-wrought-iron-diagram.svg';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 15000);
  };

  // Converts on-page SVG or an existing logo image to embedded JPEG bytes.
  async function jpegFromImage(source, maxWidth, maxHeight) {
    if (!source) return null;
    let objectURL;
    let img = source;
    try {
      if (source instanceof SVGElement) {
        const svg = source.cloneNode(true);
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        objectURL = URL.createObjectURL(new Blob(
          [new XMLSerializer().serializeToString(svg)],
          {type:'image/svg+xml;charset=utf-8'}
        ));
        img = new Image();
      } else if (typeof source === 'string') {
        img = new Image();
        img.crossOrigin = 'anonymous';
      }
      const url = objectURL || (typeof source === 'string' ? source : null);
      if (url) {
        await new Promise((resolve,reject) => {
          let settled = false;
          const cleanup = () => {
            img.onload = null;
            img.onerror = null;
            clearTimeout(timer);
          };
          const done = err => {
            if (settled) return;
            settled = true;
            cleanup();
            if (err) reject(err); else resolve();
          };
          const timer = setTimeout(() => done(new Error('Image loading timed out')), 4000);
          img.onload = () => done();
          img.onerror = () => done(new Error('Image could not be loaded'));
          img.src = url;
          if (img.complete && img.naturalWidth > 0) done();
        });
      } else if (!img.complete || !img.naturalWidth) {
        throw new Error('Image is not ready');
      }
      const width = img.naturalWidth || 800, height = img.naturalHeight || 500;
      const scale = Math.min(maxWidth / width, maxHeight / height, source instanceof SVGElement ? 4 : 1);
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(width * scale));
      canvas.height = Math.max(1, Math.round(height * scale));
      const ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('Canvas context unavailable');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0,0,canvas.width,canvas.height);
      ctx.drawImage(img,0,0,canvas.width,canvas.height);
      const uri = canvas.toDataURL('image/jpeg', source instanceof SVGElement ? 0.98 : 0.9);
      const raw = atob(uri.slice(uri.indexOf(',')+1));
      return {bytes:Uint8Array.from(raw,c=>c.charCodeAt(0)),width:canvas.width,height:canvas.height};
    } catch (err) {
      console.warn('SG PDF: image unavailable; continuing report without it.',err);
      return null;
    } finally {
      if (objectURL) URL.revokeObjectURL(objectURL);
    }
  }

  function pdfBuilder() {
    const parts = [encoder.encode('%PDF-1.4\n%SGWI\n')];
    const offsets = [0];
    let size = parts[0].length;
    const add = data => { const bytes = data instanceof Uint8Array ? data : encoder.encode(data); parts.push(bytes); size += bytes.length; };
    const obj = (id,body,stream) => {
      offsets[id] = size;
      add(id + ' 0 obj\n' + body);
      if (stream) { add('\nstream\n'); add(stream); add('\nendstream'); }
      add('\nendobj\n');
    };
    const finish = count => {
      const xref = size;
      add('xref\n0 ' + (count+1) + '\n0000000000 65535 f \n');
      for(let i=1;i<=count;i++) add(String(offsets[i]||0).padStart(10,'0')+' 00000 n \n');
      add('trailer\n<< /Size '+(count+1)+' /Root 1 0 R >>\nstartxref\n'+xref+'\n%%EOF');
      return new Blob(parts,{type:'application/pdf'});
    };
    return {obj,finish};
  }

  function slug(s) { return ascii(s).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,60); }
  function textLine(x,y,string,size=11,font='F1',color='0.16 0.16 0.15') {
    return `${color} rg BT /${font} ${size} Tf 1 0 0 1 ${x.toFixed(1)} ${y.toFixed(1)} Tm ${pdfstr(string)} Tj ET\n`;
  }
  function wrapText(s,maxLength=92) {
    const words=ascii(s).split(/\s+/);const lines=[];let line='';
    for (const word of words) {if((line+' '+word).trim().length>maxLength){if(line)lines.push(line);line=word;}else line=(line+' '+word).trim();}
    if(line)lines.push(line);return lines;
  }

  api.savePDF = async function ({title,rows=[],diagram,disclaimer}) {
    const site='https://sgwroughtiron.co.uk/';
    const logoElement=document.querySelector('header img[alt*="Wrought" i], header img[src*="logo" i], .header__heading-logo, .header__logo img');
    const logoSrc=api.logoUrl||(logoElement&&(logoElement.currentSrc||logoElement.src));
    const [logo,figure]=await Promise.all([
      logoSrc?jpegFromImage(logoSrc,550,180):Promise.resolve(null),
      diagram?jpegFromImage(diagram,2400,1200):Promise.resolve(null)
    ]);
    const pdf=pdfBuilder();
    const isBay=/bay/i.test(title); const W=isBay?841.89:595.28,H=isBay?595.28:841.89,x=isBay?40:53,right=W-x,width=W-2*x;
    // PDF-native coordinate geometry and clickable header annotations.
    const n=Boolean(logo)+Boolean(figure);
    let id=5;
    const logoId=logo?++id:null, figId=figure?++id:null;
    const brandLinkId=++id,webLinkId=++id,contentId=++id;
    const resources=`/Font << /F1 3 0 R /F2 4 0 R >>`+
      (n?` /XObject << ${logo?`/Logo ${logoId} 0 R`:''} ${figure?`/Figure ${figId} 0 R`:''} >>`:'');
    pdf.obj(1,'<< /Type /Catalog /Pages 2 0 R >>');
    pdf.obj(2,'<< /Type /Pages /Kids [5 0 R] /Count 1 >>');
    pdf.obj(3,'<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>');
    pdf.obj(4,'<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold >>');
    let out='';
    const fill=(hex)=>{const c=hex.match(/../g).map(v=>parseInt(v,16)/255);return c.map(v=>v.toFixed(3)).join(' ')+' rg\n';};
    const rect=(xx,yy,ww,hh,hex)=>{out+=fill(hex)+`${xx} ${yy} ${ww} ${hh} re f\n`;};
    const line=(a,b,c,d,hex='D8D8D8')=>{const t=hex.match(/../g).map(v=>parseInt(v,16)/255).map(v=>v.toFixed(3)).join(' ');out+=`${t} RG 0.8 w ${a} ${b} m ${c} ${d} l S\n`;};
    const T=(xx,yy,s,pt=10,bold=false,col='212121')=>{out+=textLine(xx,yy,s,pt,bold?'F2':'F1',col.match(/../g).map(v=>(parseInt(v,16)/255).toFixed(3)).join(' '));};
    const formattedDate=new Date().toLocaleDateString('en-GB',{day:'numeric',month:'long',year:'numeric'});

    if (isBay) {
      // Landscape A4: reference layout, with SG Wrought Iron branding.
      if(logo){const lh=30,lw=Math.min(45,lh*logo.width/logo.height);out+=`q ${lw.toFixed(2)} 0 0 ${lh} 40 526 cm /Logo Do Q\n`;}
      T(logo?98:40,544,'SG WROUGHT IRON',17,true);
      T(logo?98:40,527,'MADE TO MEASURE  /  SIZING TOOLS',8,false,'636363');
      T(646,546,'BAY WINDOW MEASUREMENT GUIDE',9,true);
      T(716,529,'sgwroughtiron.co.uk',8,false,'404040');
      line(40,509,802,509);
      T(40,473,'Bay Window Measurements',23,true);
      T(647,474,'Generated: '+formattedDate,8,false,'595751');
      T(40,455,'A proportional measuring guide generated from your calculator inputs.',9,false,'595751');
      const tableX=40,tableW=251,panelY=94,panelH=339,diagramX=313,diagramW=489;
      rect(tableX,panelY,tableW,panelH,'FFFFFF');
      rect(tableX,panelY+panelH-32,tableW,32,'212121');
      T(tableX+14,panelY+panelH-21,'CALCULATED RESULTS',9,true,'FFFFFF');
      const maxRows=Math.min(rows.length,10);
      const rowHeight=Math.min(30,(panelH-42)/Math.max(1,maxRows));
      rows.slice(0,maxRows).forEach((row,i)=>{
        const y=panelY+panelH-32-(i+1)*rowHeight;
        if(i%2===1)rect(tableX,y,tableW,rowHeight,'F0F0F0');
        T(tableX+12,y+rowHeight/2-3.5,String(row[0]??'').slice(0,37),8);
        T(tableX+tableW*.68,y+rowHeight/2-3.5,String(row[1]??'').slice(0,20),9,true);
      });
      rect(diagramX,panelY,diagramW,panelH,'F0F0F0');
      T(diagramX+20,panelY+panelH-27,'TOP VIEW - DIMENSIONS IN MM',9,true,'636363');
      if(figure){
        const scale=Math.min((diagramW-32)/figure.width,(panelH-83)/figure.height);
        const fw=figure.width*scale,fh=figure.height*scale;
        const fx=diagramX+(diagramW-fw)/2,fy=panelY+43+(panelH-83-fh)/2;
        out+=`q ${fw.toFixed(2)} 0 0 ${fh.toFixed(2)} ${fx.toFixed(2)} ${fy.toFixed(2)} cm /Figure Do Q\n`;
      } else {
        T(diagramX+110,panelY+160,'Measurement diagram unavailable',11,false,'636363');
      }
    } else {
    // Branding/header - web name, text and optional logo all share the same clickable destination.
    if(logo){const lh=35,lw=Math.min(43,lh*logo.width/logo.height);out+=`q ${lw.toFixed(2)} 0 0 ${lh} ${x} 765 cm /Logo Do Q\n`;}
    T(logo?x+54:x,781,'SG WROUGHT IRON',16,true);
    T(logo?x+54:x,766,'MADE TO MEASURE  /  SIZING TOOLS',8,false,'636363');
    T(426,784,(/bay/i.test(title)?'BAY WINDOW GUIDE':'CURTAIN SIZE GUIDE'),8,true,'333333');
    T(426,768,'sgwroughtiron.co.uk',9,false,'404040');
    line(x,748,right,748);
    T(x,716,/bay/i.test(title)?'Bay Window Estimate':'Curtain Size Estimate',23,true);
    T(399,715,'Generated: '+formattedDate,8,false,'595751');
    T(x,699,'Measurements are a guide - confirm dimensions before ordering.',9,false,'595751');
    // Large beige drawing panel ABOVE the result table, matching legacy SG Curtain Poles report.
    rect(x,377,width,299,'F0F0F0');
    T(x+30,652,(/bay/i.test(title)?'TOP VIEW':'FRONT ELEVATION')+' / NOT TO SCALE FOR MANUFACTURING',8,false,'636363');
    if(figure){
      const scale=Math.min(444/figure.width,220/figure.height);
      const fw=figure.width*scale,fh=figure.height*scale;
      const fx=(W-fw)/2,fy=415+(210-fh)/2;
      out+=`q ${fw.toFixed(2)} 0 0 ${fh.toFixed(2)} ${fx.toFixed(2)} ${fy.toFixed(2)} cm /Figure Do Q\n`;
    }else{
      T(x+115,530,'Measurement illustration unavailable',12,false,'636363');
    }
    // Captions from actual current rows, no fabricated values.
    const findRow=q=>{const match=rows.find(r=>String(r[0]).toLowerCase().includes(q));return match?String(match[1]):null;};
    const cap=/bay/i.test(title)?'BAY WINDOW MEASUREMENT PLAN':
      [findRow('panels'),findRow('fullness'),findRow('flat width per panel')].filter(Boolean).join('  /  ');
    T(x+45,392,cap.slice(0,86),9,false,'636363');
    // Tabular results.
    rect(x,341,width,30,'212121');T(x+15,352,'CALCULATION RESULTS',9,true,'FFFFFF');
    let y=316;const rowHeight=27;
    rows.slice(0,10).forEach((item,index)=>{
      if(index%2===1)rect(x,y-8,width,rowHeight,'F0F0F0');
      T(x+15,y,String(item[0]??'').slice(0,55),9);
      T(x+width*.57,y,String(item[1]??'').slice(0,33),9,true);
      y-=rowHeight;
    });
    // No footer. Disclaimer is included as a short note only if room permits.
    if(disclaimer&&y>52){const lines=wrapText(disclaimer,98).slice(0,2);lines.forEach((str,i)=>T(x,y-5-i*12,str,8,false,'595751'));}

    }
    const data=encoder.encode(out);
    pdf.obj(5,`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${W} ${H}] /Resources << ${resources} >> /Contents ${contentId} 0 R /Annots [${brandLinkId} 0 R ${webLinkId} 0 R] >>`);
    if(logo)pdf.obj(logoId,`<< /Type /XObject /Subtype /Image /Width ${logo.width} /Height ${logo.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${logo.bytes.length} >>`,logo.bytes);
    if(figure)pdf.obj(figId,`<< /Type /XObject /Subtype /Image /Width ${figure.width} /Height ${figure.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${figure.bytes.length} >>`,figure.bytes);
    const annotation=area=>`<< /Type /Annot /Subtype /Link /Rect [${area.join(' ')}] /Border [0 0 0] /A << /S /URI /URI ${pdfstr(site)} >> >>`;
    pdf.obj(brandLinkId,annotation(isBay?[40,516,360,557]:[x,757,375,804]));
    pdf.obj(webLinkId,annotation(isBay?[640,517,802,555]:[421,763,542,789]));
    pdf.obj(contentId,`<< /Length ${data.length} >>`,data);
    const blob=pdf.finish(contentId),url=URL.createObjectURL(blob),a=document.createElement('a');
    a.href=url;a.download=`sg-wrought-iron-${slug(title||'calculator')}-${new Date().toISOString().slice(0,10)}.pdf`;
    document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);
  };
  api.printReport=data=>api.savePDF(data).catch(err=>{console.error('SG PDF export failed',err);alert('PDF could not be generated. Please try again.');});
})(window.SGCalculator);
